import axiosInstance, { axiosNAKBHOInstance } from "../../interceptor/intercetptor-inctence"



export const getPatientLedger = (data) => {
	return axiosInstance.post(`pharma/get-pending-payments`, data);
}

export const addLedgerPayment = (data) => {
	return axiosInstance.post(`pharma/pay-pending-payment`, data);
}

export const viewLedgerPayment = (data) => {
	return axiosInstance.post(`pharma/get-patient-payments`, data);
}